import React from 'react'
// import LeftTextMainBanner from './LeftTextMainBanner'
// import RightTextMainBanner from './RightTextMainBanner'
import CenterTextMainBanner from './CenterTextMainBanner'

function TextMainBannerWrapper({Heading,Image}) {
  return (
    <>

        {/* <LeftTextMainBanner Heading={Heading}/> */}
        {/* <RightTextMainBanner Heading={Heading}/> */}
        <CenterTextMainBanner Heading={Heading} Image={Image}/>
      
    </>
  )
}

export default TextMainBannerWrapper;
